var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_2_",
    "data-name": "instagram (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.468,
    height: 29.469,
    viewBox: "0 0 29.468 29.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160702",
    "data-name": "Group 160702",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160701",
    "data-name": "Group 160701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M22.106,0H7.372A7.389,7.389,0,0,0,0,7.367V22.1a7.39,7.39,0,0,0,7.367,7.367H22.106A7.39,7.39,0,0,0,29.473,22.1V7.367A7.389,7.389,0,0,0,22.106,0Zm4.911,22.1a4.917,4.917,0,0,1-4.911,4.911H7.372A4.917,4.917,0,0,1,2.461,22.1V7.367A4.917,4.917,0,0,1,7.372,2.456H22.106a4.916,4.916,0,0,1,4.911,4.911V22.1Z",
    transform: "translate(-0.005)",
    fill: "#231c5f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160704",
    "data-name": "Group 160704",
    transform: "translate(20.874 4.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160703",
    "data-name": "Group 160703"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    fill: "#231c5f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160706",
    "data-name": "Group 160706",
    transform: "translate(7.367 7.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160705",
    "data-name": "Group 160705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M109.772,102.4a7.367,7.367,0,1,0,7.367,7.367A7.366,7.366,0,0,0,109.772,102.4Zm0,12.279a4.912,4.912,0,1,1,4.911-4.912A4.912,4.912,0,0,1,109.772,114.679Z",
    transform: "translate(-102.405 -102.4)",
    fill: "#231c5f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram (2).142718d4131c9c12c28f5e5f7e6b60cd.svg";
export { ForwardRef as ReactComponent };